export default function sanitizeForParam(fragment) {
  return (fragment || "")
    .toString()
    .replace(/[^a-z0-9]/gi, "_")
    .toLowerCase();
}
